if (!customElements.get('image-lightbox')) {
  customElements.define(
    'image-lightbox',
    class ImageLightbox extends ModalDialog {
      constructor() {
        super();
        this.slides = this.querySelectorAll('.image-lightbox__slide');
        this.prevBtn = this.querySelector('.image-lightbox__nav--prev');
        this.nextBtn = this.querySelector('.image-lightbox__nav--next');
        this.counter = this.querySelector('.image-lightbox__counter');
        this.currentIndex = 0;
        this.totalSlides = this.slides.length;

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.showSlide(this.currentIndex - 1);
          });
        }

        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.showSlide(this.currentIndex + 1);
          });
        }

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.showSlide(this.currentIndex - 1);
          } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.showSlide(this.currentIndex + 1);
          }
        });

        this.touchStartX = 0;
        this.addEventListener('touchstart', (e) => {
          this.touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        this.addEventListener('touchend', (e) => {
          const diff = this.touchStartX - e.changedTouches[0].screenX;
          if (Math.abs(diff) > 50) {
            if (diff > 0) {
              this.showSlide(this.currentIndex + 1);
            } else {
              this.showSlide(this.currentIndex - 1);
            }
          }
        }, { passive: true });

        // Close on backdrop click. ModalDialog only closes when the click
        // target is the <image-lightbox> element itself, but our dialog fills
        // it 100%, so those clicks never reach it. Treat clicks that land on
        // the structural wrappers (the dark area around the content) as a
        // backdrop click; clicks on images, videos, panels, and controls sit
        // deeper and are left alone.
        //
        // Exception: where the dialog is a bottom sheet it no longer fills the
        // viewport — it IS the card, and the exposed area above it is the
        // <image-lightbox> itself, so ModalDialog's own handler covers the
        // backdrop. Running this one there would close the sheet whenever the
        // card's own background was tapped.
        this.addEventListener('click', (e) => {
          if (this.isBottomSheet()) return;
          if (
            e.target.classList.contains('image-lightbox__dialog') ||
            e.target.classList.contains('image-lightbox__content') ||
            e.target.classList.contains('image-lightbox__slide')
          ) {
            this.hide();
          }
        });
      }

      // The Instagram lightbox renders as a bottom sheet on phones; other
      // consumers (lookbook, colour chart) keep the full-viewport dialog.
      isBottomSheet() {
        return (
          this.classList.contains('instagram-lightbox') &&
          window.matchMedia('(max-width: 749px)').matches
        );
      }

      connectedCallback() {
        super.connectedCallback();
        this.bindTriggers();
      }

      bindTriggers() {
        const sectionId = this.dataset.section;
        const section = document.getElementById(`shopify-section-${sectionId}`);
        if (!section) return;

        section.querySelectorAll('.image-lightbox__trigger').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            this.currentIndex = parseInt(trigger.dataset.lightboxIndex, 10) || 0;
            this.show(trigger);
          });
        });
      }

      show(opener) {
        super.show(opener);
        this.showSlide(this.currentIndex);
      }

      showSlide(index) {
        if (index < 0) index = 0;
        if (index >= this.totalSlides) index = this.totalSlides - 1;
        this.currentIndex = index;

        this.slides.forEach((slide, i) => {
          slide.classList.toggle('active', i === index);
        });

        this.preloadAdjacent(index);

        if (this.prevBtn) {
          this.prevBtn.disabled = index === 0;
        }
        if (this.nextBtn) {
          this.nextBtn.disabled = index === this.totalSlides - 1;
        }

        if (this.counter) {
          this.counter.textContent = `${index + 1} / ${this.totalSlides}`;
        }
      }

      preloadAdjacent(index) {
        [index - 1, index + 1].forEach((i) => {
          if (i < 0 || i >= this.totalSlides) return;
          const img = this.slides[i].querySelector('img');
          if (img) img.loading = 'eager';
        });
      }
    }
  );
}
